import { PayPalScriptProvider, type ReactPayPalScriptOptions } from '@paypal/react-paypal-js';
import { useSiteContext } from '@eti/providers';
import type { ReactNode } from 'react';
import { getPayPalLocaleFromLocaleCode } from '../payment-methods/paypal/utils/locale';
import PaymentMethodsContext from '../payment-methods/context/PaymentMethodsContext';
import { usePayPal } from '../payment-methods/paypal/hooks/usePayPal';
import type { TransformedPaymentMethod } from '../models';
import Loading from '../../../common/loading/components/Loading';

interface PaymentPageProviderProps {
  children: ReactNode;
  paymentMethods: TransformedPaymentMethod[];
}

const PaymentPageProvider = ({ children, paymentMethods }: PaymentPageProviderProps) => {
  const { payPalSessionData, payPalClientId, hasPaypalPaymentMethod } = usePayPal(paymentMethods);
  const { siteCurrency, language } = useSiteContext();

  if (hasPaypalPaymentMethod && !payPalSessionData) {
    return <Loading />;
  }

  const payPalScriptOptions: ReactPayPalScriptOptions = {
    clientId: payPalClientId ?? '',
    components: ['buttons', 'funding-eligibility', 'messages'],
    currency: siteCurrency.code,
    dataUserIdToken: payPalSessionData ?? '',
    intent: 'authorize',
    locale: getPayPalLocaleFromLocaleCode(language.locale),
  };

  return (
    <PayPalScriptProvider deferLoading options={payPalScriptOptions}>
      <PaymentMethodsContext>{children}</PaymentMethodsContext>
    </PayPalScriptProvider>
  );
};

export default PaymentPageProvider;
